/**
 * Line icons matching the prototype's Lucide-style set: 24px grid, 1.75px
 * stroke, round caps. Rendered at 16px by default (14px in dense rows).
 */
export function Glyph({
  d,
  size = 16,
  className,
  title,
  strokeWidth = 1.75,
}: {
  d: string | readonly string[];
  size?: number;
  className?: string;
  title?: string;
  strokeWidth?: number;
}): React.ReactElement {
  const paths = Array.isArray(d) ? d : [d];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      focusable="false"
      className={className}
    >
      {title ? <title>{title}</title> : null}
      {paths.map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  );
}

export const ICON = {
  file: ['M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z', 'M14 3v5h5'],
  search: ['M11 11m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0', 'm21 21-4.3-4.3'],
  plus: ['M12 5v14', 'M5 12h14'],
  menu: ['M4 6h16', 'M4 12h16', 'M4 18h16'],
  more: ['M5 12h.01', 'M12 12h.01', 'M19 12h.01'],
  chevron: 'm9 6 6 6-6 6',
  userPlus: [
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2',
    'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
    'M19 8v6',
    'M22 11h-6',
  ],
  sliders: [
    'M4 6h10',
    'M18 6h2',
    'M4 12h4',
    'M12 12h8',
    'M4 18h12',
    'M14 4v4',
    'M8 10v4',
    'M16 16v4',
  ],
  link: [
    'M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7',
    'M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7',
  ],
  upload: ['M12 16V4', 'M7 9l5-5 5 5', 'M5 20h14'],
  comment: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  star: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  back: ['M19 12H5', 'm12 19-7-7 7-7'],
  forward: ['M5 12h14', 'm12 5 7 7-7 7'],
  close: 'M6 6l12 12 M18 6L6 18',
  copy: ['M9 9h11v11H9z', 'M5 15V6a2 2 0 0 1 2-2h9'],
  settings: [
    'M4 6h10',
    'M18 6h2',
    'M4 12h4',
    'M12 12h8',
    'M4 18h12',
    'M20 18h0',
    'M14 4v4',
    'M8 10v4',
    'M16 16v4',
  ],
  plug: ['M9 3v5', 'M15 3v5', 'M6 8h12v4a6 6 0 0 1-12 0z', 'M12 18v3'],
  key: ['M7 14a4 4 0 1 1 3.9-5H21v3h-2v2h-3v-2h-5.1A4 4 0 0 1 7 14z', 'M7 10h.01'],
  terminal: [
    'M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z',
    'M8 10l3 2-3 2',
    'M13 15h3',
  ],
  bolt: ['M3 12h4l2-6 3 12 2-6h3'],
  download: ['M12 4v12', 'M7 11l5 5 5-5', 'M5 20h14'],
} as const;
